import '@mdi/font/css/materialdesignicons.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import '../css/app.css'
import {createApp, h} from 'vue'
import {createInertiaApp} from '@inertiajs/vue3'
import 'vuetify/styles'
import {createVuetify} from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import {VIconBtn} from 'vuetify/labs/VIconBtn'
import * as Sentry from "@sentry/vue";
import {en} from 'vuetify/locale'
import {createRulesPlugin} from "vuetify/labs/rules";

const customLightTheme = {
    dark: false,
    colors: {
        primary: '#365BC7',
        secondary: '#322C8D',
        info: '#57BCB3',
        warning: '#F9810B',
        error: '#D2140F',
    },
}

const customDarkTheme = {
    dark: true,
    colors: {
        primary: '#365BC7',
        secondary: '#322C8D',
        info: '#57BCB3',
        warning: '#F9810B',
        error: '#D2140F',
    },
}

const vuetify = createVuetify({
    locale: {
        locale: 'en',
        messages: {en}
    },
    aliases: {
    },
    defaults: {
        VListSubheader: {
            class: 'font-weight-bold'
        },
        VBtn: {
            variant: 'flat',
            color: 'primary',
            rounded: 'lg',
            class: 'text-none text-body-2 font-weight-medium',
        },
        VTextField: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary',
            bgColor: 'white',
            rounded: 'lg'
        },
        VTextarea: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary',
            bgColor: 'white',
        },
        VSelect: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary',
            bgColor: 'white',
        },
        VAutocomplete: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary',
            bgColor: 'white',
        },
        VCombobox: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary',
            bgColor: 'white',
        },
        VTextArea: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary',
            bgColor: 'white',
        },
        VFileInput: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary',
            bgColor: 'white',
        },
        global: {
            style: {
                fontFamily: 'Inter, sans-serif',
            }
        }
    },
    components: {
        VIconBtn,
        ...components,
    },
    directives,
    theme: {
        defaultTheme: 'customLightTheme',
        themes: {
            customLightTheme,
            customDarkTheme
        },
    },
    icons: {
        defaultSet: 'mdi',
    },
})

createInertiaApp({
    progress: {
        delay: 250,
        color: '#29d',
        top: '64px',
        includeCss: true,
        showSpinner: false,
    },
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.vue', {eager: true})
        return pages[`./Pages/${name}.vue`]
    },
    setup({el, App, props, plugin}) {
        const app = createApp({render: () => h(App, props)})

        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
            integrations: [
                Sentry.browserTracingIntegration(),
            ],

            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for tracing.
            // We recommend adjusting this value in production
            tracesSampleRate: 1.0,

            // Capture Replay for 10% of all sessions,
            // plus for 100% of sessions with an error
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });

        app.use(plugin)
            .use(createRulesPlugin({}, vuetify.locale))
            .use(vuetify)
            .mount(el)
    },
})
